import { baseApi } from "./baseApi";

const configurationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureFlags: builder.query({
      query: () => ({
        url: "/configuration/feature-flags",
        method: "GET",
      }),
      providesTags: ["FeatureFlags"],
    }),

    saveFeatureFlags: builder.mutation({
      query: (body) => ({
        url: "/configuration/feature-flags",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["FeatureFlags"],
    }),

    getPiperAccess: builder.query({
      query: () => ({
        url: "/configuration/piper-access",
        method: "GET",
      }),
      providesTags: ["PiperAccess"],
    }),

    recordPiperTerms: builder.mutation({
      query: ({ accepted }) => ({
        url: "/users/me/piper-terms",
        method: "POST",
        body: { accepted },
      }),
      invalidatesTags: ["PiperAccess"],
    }),
  }),
});

export default configurationApi;
